//React Library
import React, { useState, useEffect } from "react";

//Material UI Styles
import { makeStyles } from "@material-ui/core/styles";

//Material UI Components
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import TextField from "@material-ui/core/TextField";
import moment from "moment";
import IconButton from "@material-ui/core/IconButton";
import MuiPhoneNumber from "material-ui-phone-number";
import Visibility from "@material-ui/icons/Visibility";
import FormControl from "@material-ui/core/FormControl";
import { CircularProgress } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import PhotoCamera from "@material-ui/icons/PhotoCamera";
import CustomToolTip from "../../Global/PasswordGuileline";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import PhoneInput from "react-phone-number-input/input";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import DeleteIcon from "@material-ui/icons/Delete";
import TableRow from "@material-ui/core/TableRow";
import { Switch } from "@material-ui/core";
import { styled } from "@material-ui/core/styles";
import {Link} from "react-router-dom";
import { useLocation } from "react-router-dom";
import { Redirect } from "react-router";
//Global Elements
import GlobalApi from "../../Global";
import Colors from "../../Global/colors";
import refresh_token from "../../Global/refresh_token";
import {
  hasValidLength,
  hasNumber,
  hasMixed,
  hasSpecial,
} from "../../Global/Password";

//Custom Css + Images
import "./account.css";
import swal from "@sweetalert/with-react";
import Delete from "../../Assets/delete.png";
import Edit from "../../Assets/edit.png";
import DeleteG from "../../Assets/deleteG.png";
import EditG from "../../Assets/editG.png";
import packageImg from "../../Assets/package.png";
import Annual from "../../Assets/annual.png";


//Redux
import { addUser } from "../../Redux/Actions/userAction";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  input: {
    display: "none",
  },
  textField: {
    backgroundColor: Colors.globalColor5,
    border: "none",
    borderRadius: 5,
  },
  resize: {
    padding: "7px",
  },
  password: {
    padding: "2px",
  },
  switchBase: {
    color: "#818181",
    padding: "1px",
    "&$checked": {
      "& + $track": {
        backgroundColor: "#043077",
      },
    },
  },
  thumb: {
    color: "white",
    width: "20px",
    height: "20px",
    margin: "1px",
  },
  track: {
    borderRadius: "20px",
    width: "200px",
    backgroundColor: "#818181",
    opacity: "1 !important",
    "&:after, &:before": {
      color: "white",
      fontSize: "11px",
      backgroundColor: "#818181",
    },
    "&:after": {
      content: "'activate'",
      left: "7px",
    },
    "&:before": {
      content: "'deactivate'",
      right: "8px",
    },
  },
  checked: {
    color: "#043077 !important",
    transform: "translateX(50px) !important",
  },
}));

//Main Function
function Team() {
  const history = useHistory();
  const {t} = useTranslation();
  let language = useSelector((state) => state.languageReducer.language);
  let data = useSelector((state) => state.companyReducer.company);
  let company = useSelector((state) => state.companyReducer.company);
  let data2 = useSelector((state) => state.userReducer.user);
  const [currentCompany, setCurrentCompany] = useState(data);
  const [btnLoader, setBtnLoader] = useState(false);
  const [btnLoader2, setBtnLoader2] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [companiesArr, setCompaniesArr] = useState([]);
  const [profileImageUrl, setProfileImageUrl] = useState("");
  const [signatureUrl, setSignatureUrl] = useState("");
  const [userData, setUserData] = useState("");
  const [packageDetails, setPackageDetails] = useState(null);
  const [token, setToken] = useState(data2.token);
  const [organizationId, setOrganizationId] = useState(data2.organization_id);
  const [editMode, setEditMode] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [currentEditUser, setCurrentEditUser] = useState("");
  const [teams, setTeams] = useState(null);
  const location = useLocation();
  const fileSizeRedux = useSelector((state) => state.reducer.fileSize);
  const [packageCurrentDetails, setPackageCurrentDetails] = React.useState({});
    const [packageExpired, setPackageExpired] = React.useState(false);
  const [permissions_obj, setPermissionObj] = useState({});
  const [profileData, setProfileData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    profilePic:null,
  });
  const [passwordData, setPasswordData] = useState({
    old_password: "",
    new_password: "",
    confirm_new_password: "",
  });

  let [errorObj, setErrorObj] = useState({
    first_name: "",
    last_name: "",
    email: "",
    profilePic:null,
  });
  let [passwordErrorObj, setPasswordErrorObj] = useState({
    old_password: "",
    new_password: "",
    confirm_new_password: "",
  });

  const [values, setValues] = React.useState({
    showOldPassword: false,
    showPassword: false,
    showPasswordConfirm: false,
  });
  const dispatch = useDispatch();

  function handleInputChange(event) {
    let { name, value } = event.target;
    setProfileData({
      ...profileData,
      [name]: value,
    });
  }


  function handleInputPasswordChange(event) {
    let { name, value } = event.target;
    setPasswordData({
      ...passwordData,
      [name]: value,
    });
  }

  // function getCurrentPackage() {
  //   let localstorage = localStorage.getItem("UserData");
  //   var data = JSON.parse(localstorage);
  //   let token = data?.token;
  //   let params = {
  //     organization_id: data?.organization_id,
  //   };
  //   // console.log(data.user_id);
  //   let query = Object.keys(params)
  //     .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
  //     .join("&");

  //   fetch(GlobalApi + "/Package/get_package_inspection_limit?" + query, {
  //     method: "GET",
  //     headers: {
  //       Authorization: "Bearer " + token,
  //       "Content-Type": "application/json",
  //     },
  //   })
  //     .then((responseJson) => responseJson.json())
  //     .then(async (response) => {
  //       console.log(
  //         "response of get packageCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCC",
  //         response
  //       );
  //       if (response.status === "Request is Valid") {
  //         console.log(response);
  //         setPackageCurrentDetails(response.data);
  //       } else {
  //         setPackageCurrentDetails("expired");
  //       }
  //     })
  //     .catch((error) => console.log(error.message));
  // }
  

  // function getPackage() {
  //   let localstorage = localStorage.getItem("UserData");
  //   var data = JSON.parse(localstorage);
  //   let token = data?.token;
  //   let params = {
  //     organization_id: data?.organization_id,
  //   };
  //   // console.log(data.user_id);
  //   let query = Object.keys(params)
  //     .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
  //     .join("&");

  //   fetch(GlobalApi + "/Package/get_package_history?" + query, {
  //     method: "GET",
  //     headers: {
  //       Authorization: "Bearer " + token,
  //       "Content-Type": "application/json",
  //     },
  //   })
  //     .then((responseJson) => responseJson.json())
  //     .then(async (response) => {
  //       console.log(
  //         "response of get packageYYYYYYYYYYYYYYYYYYYYYYYYYYYY_______________________________________________",
  //         response
  //       );
  //       if (response.status === "Success") {
  //         // console.log(response.data);
  //         if(new Date(response.data.expiry_date) < new Date()){
  //           setPackageExpired(true);  
  //         }

  //         if (response.data === null) {
  //           setPackageExpired(true);
  //           if (
  //             response.status === "Expired" &&
  //             location.pathname == "/blocked"
  //           ) {
  //             // console.log("location", location.pathname);
  //             return;
  //           }
  //           // history.replace("/update_package");
  //           return;
  //         }

  //         setPackageDetails(response.data);
  //       } else if (
  //         response.error === "jwt expired" ||
  //         response.error === "invalid token" ||
  //         response.error === "invalid signature" ||
  //         response.error === "Unexpected token"
  //       ) {
  //         let status = await refresh_token();
  //         if (status) {
  //           getPackage();
  //         }
  //       }
  //     })
  //     .catch((error) => console.log(error.message));
  // }




  function handlePhoneInputChange(value) {
    console.log(value);
    setProfileData({
      ...profileData,
      phone: value,
    });
  }

  const handleClickShowOldPassword = () => {
    setValues({ ...values, showOldPassword: !values.showOldPassword });
  };

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };
  const handleClickShowPasswordConfirm = () => {
    setValues({ ...values, showPasswordConfirm: !values.showPasswordConfirm });
  };





  const handleCancel = () => {
    setEditMode(false);
    setProfileData({
        first_name: userData.first_name,
        last_name: userData.last_name,
        email: userData.email,
        profilePic: userData.avatar,
    });
    setPhoneNumber(userData.phone);
    setErrorObj({first_name: "",
    last_name: "",
    email: "",
    profilePic:null,})

    setPasswordErrorObj({
      old_password: "",
      new_password: "",
      confirm_new_password: "",
    })

    setPasswordData({
      old_password: "",
      new_password: "",
      confirm_new_password: "",
    });

  };




  const getUserData = () => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let tokenNew = data.token;

    let params = { userID: data.user_id };
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");
    fetch(GlobalApi + "/user/get_user_account?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + tokenNew,          
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        console.log("RESPONSE PROFILE >>>>", response);
        setUserData(response.user)
        setProfileData({
            first_name: response.user.first_name,
            last_name: response.user.last_name,
            email: response.user.email,
            profilePic:response.user.avatar,
            oldPassword: "",
            password: "",
        });
        setPhoneNumber(response.user.phone);
      })
      .catch((error) => console.log(error.message));
  };

  useEffect(
    () => {
      // setCurrentCompany(data);
      getPackageDetails()
      // getPackage();
      getUserData();
      // getCurrentPackage()
    },
    []
  );


  const getPackageDetails = async () => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    if (data == undefined) {
      return <Redirect to={"/signin"} />;
    }
    let package_inquiry = {
      user_id: data.user_id,
      organization_id: data.organization_id,
    };

    let query = Object.keys(package_inquiry)
      .map(
        (k) =>
          encodeURIComponent(k) + "=" + encodeURIComponent(package_inquiry[k])
      )
      .join("&");
    let req = await fetch(
      GlobalApi + "/Package/get_user_license_details?" + query,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );

    let reqJson = await req.json();

  
    if (reqJson?.package?.license?.status === "expired" || reqJson?.package?.license?.status === "deactive") {
      setPackageExpired(true); 
      // history.replace("/billing");
    } else {
      setPackageDetails(reqJson.package);
    }
  };


  

  let uploadProfileImage = async (singleFile = null) => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    //Check if any file is selected or not
    if (singleFile != null) {
      //If file selected then create FormData
      const fileToUpload = singleFile;
      const data = new FormData();
      data.append("name", fileToUpload.name);
      data.append("company_id", company.id);
      data.append("user_id", data.id);
      data.append("images", fileToUpload);
      try {
        let res = await fetch(GlobalApi + "/user/image_upload", {
          method: "post",
          body: data,
          headers: new Headers({
            Authorization: "Bearer " + token,
            // "Content-Type": "multipart/form-data; ",
          }),
        });
        let responseJson = await res.json();
        if (responseJson.status == "Success") {
          console.log("Image Uploaded>>>>>>>", responseJson);
          setProfileImageUrl(responseJson.data);
          setProfileData({
            ...profileData,
            profilePic: responseJson.data,
            
          });
        }
      } catch (e) {
        console.log(e);
      }
    } else {
      alert("Please Select File first");
    }
  };

  const toggleNotifications = (value) =>{

    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    let params = {
      user_id: data?.user_id,
      status:value
    };
    // console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/user/enable_disable_chat_notifications?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        console.log(
          "response of get toggle",
          response
        );
     if(response.msg == "success"){
      let newData ={
        ...data,
        enable_chat_notifications:value
    }
    dispatch(addUser(newData));
    localStorage.setItem("UserData", JSON.stringify(newData));
    if(value == false){
      swal(t("Success"),t("Action Chat Notifications Disabled"),"success")
    }else{
      swal(t("Success"),t("Action Chat Notifications Enabled"),"success")
    }
     }
      })
      .catch((error) => console.log(error.message));

  }


  const handleSubmit = (e) => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    setBtnLoader(true);
      let obj = profileData;
      let {
        first_name,
        last_name,
        email,
        profilePic,
      } = obj;
      console.log(obj);

      let errors = {};
 
      if (first_name.length <= 0) {
        errors.first_name = "First Name is required";
      }
      if (last_name.length <= 0) {
        errors.last_name = "Last Name is required";
      }

      setErrorObj(errors);

      if (Object.keys(errors).length !== 0) {
        setBtnLoader(false);
      }

      if (Object.keys(errors).length === 0) {
        fetch(GlobalApi + "/user/update_user_account", {
          method: "post",
          headers: new Headers({
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
          }),
          body: JSON.stringify({
            ...obj,
            phone: phoneNumber,
            userID:data.user_id
            // set_password_later: true,
          }),
        })
          .then((response) => response.json())
          .then(async (res) => {
    
            if (res.msg === "success") {
              setBtnLoader(false);
              swal(t("Success"), t("User details have been updated successfully"), "success");
              getUserData();
              setEditMode(false)
              let newData ={
                  ...data2,
                  ...res.user
              }
              dispatch(addUser(newData));
              localStorage.setItem("UserData", JSON.stringify(newData));
              console.log(newData)
            } else {
                console.log(res)
              swal(t("Error"), res.user, "error");
              setBtnLoader(false);
            }
          })
          .catch((err) => {
              console.log(err)
            swal(t("Error"), err.error, "error");
            setBtnLoader(false);
          });
      }
  };

  const handleReset = (e) => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    setBtnLoader2(true);
      let obj = passwordData;
      let { old_password, new_password, confirm_new_password } = obj;
      console.log(obj);

      let errors = {};

      if (old_password.length <= 0) {
        errors.old_password = "Old Password is Required";
      }
      if (!hasValidLength(new_password)) {
        errors.new_password = "Your password must have 8 or more characters";
      }
      if (!hasMixed(new_password)) {
        errors.new_password = "Your password must have upper & lowercase letters";
      }
      if (!hasNumber(new_password)) {
        errors.new_password = "Your password must have at least one number";
      }
      if (!hasSpecial(new_password)) {
        errors.new_password = "Your password must have at least one special character";
      }

      if (new_password !== confirm_new_password) {
        errors.confirm_new_password = "password mismatch";
      }

      setPasswordErrorObj(errors);

      if (Object.keys(errors).length !== 0) {
        setBtnLoader2(false);
      }

      if (Object.keys(errors).length === 0) {
        fetch(GlobalApi + "/user/update_user_account", {
          method: "post",
          headers: new Headers({
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
          }),
          body: JSON.stringify({
            oldPassword:obj.old_password,
            password:obj.new_password,
            userID:data.user_id
            // set_password_later: true,
          }),
        })
          .then((response) => response.json())
          .then(async (res) => {
    
            if (res.msg === "success") {
              setBtnLoader2(false);
              swal(t("Success"), t("Password Reset Successfully"), "success");
              setPasswordErrorObj({
                old_password: "",
                new_password: "",
                confirm_new_password: "",
              })
          
              setPasswordData({
                old_password: "",
                new_password: "",
                confirm_new_password: "",
              });
              setEditMode(false)
            } else {
                console.log(res)
              swal(t("Error"), res.user, "error");
              setBtnLoader2(false);
            }
          })
          .catch((err) => {
              console.log(err)
            swal(t("Error"), err.error, "error");
            setBtnLoader2(false);
          });
      }
  };

  const classes = useStyles();
  return <div className="" style={{ width: "100%", padding: "30px", backgroundColor: Colors.globalColor9, overflowY: "scroll" }}>
      <div style={{ backgroundColor: "white", borderRadius: "10px", boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.19)" }}>
        <Grid xs={12} justifyContent="space-between">
          <div style={{ display: "flex", justifyContent: "space-between", flexDirection: "row", padding: "20px 20px", borderBottom: "1px solid #dadada" }}>
            <div>
              <p className="label2" style={{ marginTop: "0", color: Colors.globalColor8 }}>
                {t("Account Details")}
              </p>
            </div>
            <div onClick={() => setEditMode(true)} style={{ cursor: "pointer" }}>
              <img src={Edit} alt="edit" style={{ display: "inline" }} />
              &nbsp;
              <p className="label2" style={{ display: "inline", marginTop: "0", color: Colors.globalColor8, fontSize: "12px" }}>
                {t("Edit")}
              </p>
            </div>
          </div>
        </Grid>
        <div style={{ padding: "30px" }}>
          <Grid container spacing={3} justifyContent="center">
            <Grid item xs={12} sm={2} md={2} lg={2} style={{ textAlign: "center" }}>
              <input disabled={!editMode} className={classes.input} id="icon-button-file" type="file" onChange={(e) => uploadProfileImage(e.target.files[0])} />
              <label htmlFor="icon-button-file">
                <IconButton color="primary" aria-label="upload picture" component="span" style={{ width: "120px", height: "120px", marginTop: "5%", backgroundImage: `url(https://server.uraudits.com/view?Key=${profileData.profilePic})`, backgroundSize: "cover", backgroundColor: Colors.globalColor5, boxShadow: " 0 1px 2px 0 rgba(1, 128, 141, 0.2), 0 1px 5px 0 rgba(1, 1, 141, 0.19)" }}>
                  <PhotoCamera fontSize="large" style={{ color: !profileData.profilePic ? "#dee0e1" : "transparent" }} />
                </IconButton>
              </label>
              <p className="label1Team">{t("Profile Image")}</p>
            </Grid>
            <Grid item xs={12} sm={12} md={10} lg={10}>
              <p className="label2" style={{ color: Colors.globalColor8 }}>
                {t("Profile Settings")}
              </p>
              <form>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={12} md={4} lg={4}>
                        <p className="label1Team">{t("First Name")}</p>
                        <TextField disabled={!editMode} className="inputTextBox" fullWidth id="outlined-basic" name="first_name" InputProps={{ classes: { input: classes.resize } }} error={errorObj.first_name} helperText={errorObj.first_name} onChange={handleInputChange} variant="outlined" autoComplete={"off"} size="small" value={profileData.first_name} />
                      </Grid>
                      <Grid item xs={12} sm={12} md={4} lg={4}>
                        <p className="label1Team">{t("Last Name")}</p>
                        <TextField className="inputTextBox" disabled={!editMode} fullWidth id="outlined-basic" name="last_name" InputProps={{ classes: { input: classes.resize } }} error={errorObj.last_name} helperText={errorObj.last_name} onChange={handleInputChange} variant="outlined" autoComplete={"off"} size="small" value={profileData.last_name} />
                      </Grid>
                      <Grid item xs={12} sm={12} md={4} lg={4}>
                        <p className="label1Team">{t("Email")}</p>
                        <TextField className="inputTextBox" disabled={true} fullWidth id="outlined-basic" name="email" InputProps={{ classes: { input: classes.resize } }} error={errorObj.email} helperText={errorObj.email} onChange={handleInputChange} variant="outlined" autoComplete={"off"} size="small" value={profileData.email} />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={12} md={4} lg={4}>
                        <p className="label1Team">{t("Phone")}</p>
                        <div style={{ border: "1px solid #dadada", borderRadius: "5px", backgroundColor: Colors.globalColor5, width: "100%", height: "35px", display: "flex", alignItems: "center", justifyContent: "flex-end", padding: "0px 5px" }}>
                          <PhoneInput disabled={!editMode} className="phoneInp" value={phoneNumber} autoComplete="off" onChange={setPhoneNumber} />
                        </div>
                        {/* <MuiPhoneNumber error={errorObj.phone} autoFormat={false} helperText={errorObj.phone} disableAreaCodes={true} className={classes.textField} placeholder=" " InputProps={{ startAdornment: "", classes: { input: classes.resize } }} size="small" variant="outlined" name="phone" fullWidth value={profileData.phone} onChange={handlePhoneInputChange} /> */}
                        {/* <MuiPhoneNumber error={errorObj.phone} autoFormat={true} helperText={errorObj.phone} disableAreaCodes={true} className={classes.textField} placeholder=" " InputProps={{ startAdornment: "", classes: { input: classes.resize } }} size="small" variant="outlined" name="phone" fullWidth value={phoneNumber} onChange={(e)=>handlePhoneInputChange(e)} /> */}
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={12} style={{ marginTop: "20px" }}>
                    {editMode && <>
                        <Button variant="contained" type="submit" className="addBtn" component="span" onClick={(e) => handleSubmit(e)}>
                          {btnLoader == true && <CircularProgress size={18} style={{ color: "white", marginRight: 7 }} />} {t("Update Profile")}
                        </Button>
                        &nbsp;
                        <Button variant="contained" className="cancelBtn" onClick={() => handleCancel()}>
                          {t("Cancel")}
                        </Button>
                      </>}
                  </Grid>
                </Grid>
              </form>

              <hr style={{ borderTop: "1px solid #dadada", borderBottom: "none", marginTop: 10, width: "100%", marginBottom: 20 }} />

              <p className="label2" style={{ color: Colors.globalColor8 }}>
                {t("Reset Password")}
              </p>
              <form>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={12} md={4} lg={4}>
                        <p className="label1Team">{t("Old Password")}*</p>
                        <FormControl className={(classes.password, classes.textField)} variant="outlined" fullWidth size="small" InputProps={{ classes: { input: classes.resize }, autoComplete: "off" }}>
                          <OutlinedInput disabled={!editMode} error={passwordErrorObj.old_password} size="small" helperText={passwordErrorObj.old_password} name="old_password" className={"passwordTextbox"} id="outlined-adornment-password" type={values.showOldPassword ? "text" : "password"} value={passwordData.old_password} onChange={handleInputPasswordChange} endAdornment={<InputAdornment position="end">
                                <IconButton aria-label="toggle password visibility" onClick={handleClickShowOldPassword} edge="end" className="eyeIcon">
                                  {values.showOldPassword ? <Visibility /> : <VisibilityOff />}
                                </IconButton>
                              </InputAdornment>} />
                          <span style={{ color: "red", fontSize: "12px" }}>
                            {passwordErrorObj.old_password}
                          </span>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12} md={4} lg={4}>
                        <p className="label1Team">{t("New Password")}*</p>
                        <FormControl className={(classes.password, classes.textField)} variant="outlined" fullWidth size="small" InputProps={{ classes: { input: classes.resize }, autoComplete: "off" }}>
                          <CustomToolTip>
                            <OutlinedInput disabled={!editMode} error={passwordErrorObj.new_password} size="small" helperText={passwordErrorObj.new_password} name="new_password" className={"passwordTextbox"} id="outlined-adornment-password" type={values.showPassword ? "text" : "password"} value={passwordData.new_password} onChange={handleInputPasswordChange} endAdornment={<InputAdornment position="end">
                                  <IconButton aria-label="toggle password visibility" onClick={handleClickShowPassword} edge="end" className="eyeIcon">
                                    {values.showPassword ? <Visibility /> : <VisibilityOff />}
                                  </IconButton>
                                </InputAdornment>} />
                          </CustomToolTip>
                          <span style={{ color: "red", fontSize: "12px" }}>
                            {passwordErrorObj.new_password}
                          </span>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12} md={4} lg={4}>
                        <p className="label1Team">{t("Confirm New Password")}*</p>
                        <FormControl className={classes.textField} variant="outlined" fullWidth size="small">
                          {" "}
                          <OutlinedInput disabled={!editMode} error={passwordErrorObj.confirm_new_password} helperText={passwordErrorObj.confirm_new_password} fullWidth name="confirm_new_password" className={"passwordTextbox"} size="small" id="outlined-adornment-password" type={values.showPasswordConfirm ? "text" : "password"} value={passwordData.confirm_new_password} onChange={handleInputPasswordChange} endAdornment={<InputAdornment position="end">
                                <IconButton aria-label="toggle password visibility" onClick={handleClickShowPasswordConfirm} edge="end" className="eyeIcon">
                                  {values.showPasswordConfirm ? <Visibility /> : <VisibilityOff />}
                                </IconButton>
                              </InputAdornment>} />
                          <span
                            style={{
                              color: "red",
                              fontSize: "12px",
                              marginLeft: 15,
                            }}
                          >
                            {passwordErrorObj.confirm_new_password}
                          </span>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={12} style={{ marginTop: "20px" }}>
                    {editMode && <>
                        <Button variant="contained" type="submit" className="addBtn" component="span" onClick={(e) => handleReset(e)}>
                          {btnLoader2 == true && <CircularProgress size={18} style={{ color: "white", marginRight: 7 }} />} {t("Reset Password")}
                        </Button>
                        &nbsp;
                        <Button variant="contained" className="cancelBtn" onClick={() => handleCancel()}>
                          {t("Cancel")}
                        </Button>
                      </>}
                  </Grid>
                </Grid>
              </form>
              <hr style={{ borderTop: "1px solid #dadada", borderBottom: "none", marginTop: 10, width: "100%", marginBottom: 20 }} />

              <p className="label2" style={{ color: Colors.globalColor8, marginBottom: "10px" }}>
                {t("Notification Settings")}
              </p>

              <FormControl component="fieldset">
                <FormControlLabel value="end" checked={data2.enable_chat_notifications == null ? true : data2.enable_chat_notifications}  color="primary" onChange={(e)=>toggleNotifications(e.target.checked)}   control={<Switch color="primary" />} label={t("Enable / Disable Chat Notifications")} labelPlacement="end" />
              </FormControl>

              <hr style={{ borderTop: "1px solid #dadada", borderBottom: "none", marginTop: 10, width: "100%", marginBottom: 20 }} />

              

                {packageDetails?.subscription_status && packageDetails?.subscription_status == "complete" ?
                 <>
                <p className="label2" style={{ color: Colors.globalColor8, marginBottom: "10px" }}>
                {t("Subscription Details")}
              </p>
              <Grid container spacing={2} alignItems="center">
                <Grid item>
                  <img src={Annual} width={30} />
                </Grid>
                <Grid item>
                  <div>
                    {!packageExpired ? <>
                        {" "}
                        <p style={{ marginBottom: 0, marginTop: 2, fontWeight: "bold", fontSize: "14px" }} className="UserName">
                          {t("Current Subscription")} {":"} {packageDetails?.package?.title}
                        </p>
          
                      </> : <p style={{ marginBottom: 0, marginTop: 2, fontWeight: "bold" }} className="UserName">
                        {t("PACKAGE NONE")}
                      </p>}
                  </div>
                </Grid>
              </Grid>

              {!packageExpired ? <p style={{ marginBottom: 2, marginTop: 5, fontWeight: "bold", fontSize: "12px" }} className="expiry">
                  {t("Subscription Cycle Ends on")} &nbsp;
                  {moment(new Date(packageDetails?.expiry_date)).format("MMMM DD, YYYY")}
                </p> : <p style={{ marginBottom: 2, marginTop: 0, color: "red", fontWeight: "bold", fontSize: "12px" }} className="expiry">
                  {t("License Expired")}
                </p>}
                
                </> : 
                <>
                <p className="label2" style={{ color: Colors.globalColor8, marginBottom: "10px" }}>
                {t("Package Details")}
              </p>
              <Grid container spacing={2} alignItems="center">
                <Grid item>
                  <img src={packageImg} width={30} />
                </Grid>
                <Grid item>
                  <div>
                    {!packageExpired ? <>
                        {" "}
                        <p style={{ marginBottom: 0, marginTop: 2, fontWeight: "bold", fontSize: "14px" }} className="UserName">
                          {t("Current Package")} {":"} {packageDetails?.package?.title}
                        </p>
                        {/* <p style={{ marginBottom: 2, marginTop: 0 }} className="expiry">
                          {"Data Storage: Limit "}
                          {fileSizeRedux?.toFixed(2)}
                          {"/"}
                          {packageDetails?.file_size_per_user}
                          {"MB"}
                        </p> */}
                      </> : <p style={{ marginBottom: 0, marginTop: 2, fontWeight: "bold" }} className="UserName">
                        {t("PACKAGE NONE")}
                      </p>}
                  </div>
                </Grid>
              </Grid>

              {!packageExpired ? <p style={{ marginBottom: 2, marginTop: 5, fontWeight: "bold", fontSize: "12px" }} className="expiry">
                  {t("License Expires on")} &nbsp;
                  {moment(new Date(packageDetails?.expiry_date)).format("MMMM DD, YYYY")}
                </p> : <p style={{ marginBottom: 2, marginTop: 0, color: "red", fontWeight: "bold", fontSize: "12px" }} className="expiry">
                  {t("License Expired")}
                </p>}
                </>}                


             

            
            </Grid>
          </Grid>
        </div>
        <br />
        <br />
      </div>
      <br />
      <br />
    </div>;
}

export default Team;
